import mainHead from '../views/component/mainHead';
import mainContent from '../views/component/mainContent';
import API from '../API/index';
import { parseTime, uploadFile, saveFileInfo, getNum } from '../libs/util';
import { moneyFormat } from './utils';
import store from '../store';
import Big from 'big.js';
import APIS from '../API/fileAxios/fileAxios';

export default {
  data () {
    return {
      language: this.$i18n.locale,
      templateId: '26134331172847628',
      templateVadId: '24553134429068275',
      canSubmit: false,
      dialogVisible: false,
      form: {
        id: '',
        partnerName: '',
        partnerCode: '',
        projectName: '',
        areaCode: '',
        partnerAreaCode: '',
        partnerType: '',
        partnerTypeName: '',
        finalCompanyName: '',
        finalCompanyAddress: '',
        finalUserName: '',
        finalUserPosition: '',
        finalUserTel: '',
        finalUserPhone: '',
        finalUserEmail: '',
        fundsInPlace: '',
        fundsInPlaceKey: '',
        projectBudget: 0.00,
        networkBudget: 0,
        isSupportRuijie: '',
        isSupportRuijieKey: '',
        ruijieSaleId: '',
        ruijieSaleEmail: '',
        ruijieSaleName: '',
        taxNumber: '',
        hasCooperated: '',
        hasCooperatedKey: '',
        hasCooperatedValue: '',
        projectPhase: '',
        projectPhaseKey: '',
        projectPhaseValue: '',
        projectProgressUpdate: '',
        projectRequirements: '',
        budgetFrom: '',
        executiveDepartment: '',
        participatingDepartment: '',
        dockingPeople: '',
        competitorSituation: '',
        beforeSell: '',
        status: '',
        projectStatusKey: '',
        expectedOrderDate: '',
        partnerEmail: '',
        partnerContactName: '',
        partnerPhone: '',
        projectContractor: '',
        jointVisit: '',
        jointVisitKey: '',
        // linkEmail1:
        linkManEmail1: '',
        linkManEmail2: '',
        uid: '',
        companyCode: '',
        relatedRAP: '',
        twoPartnerName: '',
        twoPartnerCode: ''

      },
      attachment: [],
      relatedRAP: [],
      allCountries: [],
      fundsInPlaceList: [],
      isSupportRuijieList: [],
      hasCooperatedList: [],
      projectPhaseList: [],
      jointVisitList: [],
      twoPartnerList: [],
      value: '',
      uploadData: {
        type: 'PRM'
      },
      uploadUrl: API.axios.defaults.baseURL + '/common/upload',
      downloadUrl: API.axios.defaults.baseURL + '/common/attachment/',
      accept: 'image/*,application/vnd.ms-powerpoint,application/vnd.openxmlformats-officedocument.presentationml.presentation,application/vnd.openxmlformats-officedocument.wordprocessingml.document,application/x-zip-compressed,application/vnd.ms-excel,application/msword,application/x-rar-compressed,application/x-compress,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,application/vnd.ms-excel,.rar',
      fileList: [],
      isUpLoad: false,
      uploadSuccess: false,
      attachmentId: '',
      attachmentName: '',
      pageloading: false,
      isShow: false,
      maxBudget: 999999999999,
      readAndAgree: false,
      draftBtnDisabled: false,
      submitBtnDisabled: false,
      saveBtnDisabled: false,
      EditFields: true,
      BrazilianTax: false,
      pickerOptions: {
        disabledDate (time) {
          // console.log(time.getFullYear() >= 2000);
          return time.getFullYear() < 2000;
        }
      }
    };
  },
  components: {
    mainHead,
    mainContent
  },
  methods: {
    handleInput (value) {
      // console.log(value.charAt(0) === '0' && value !== '0');
      if (value.charAt(0) === '0' && value !== '0') {
        // console.log(value.charAt(0) === '0' && value !== '0');
        // console.log(this.form.networkBudget, value.substring(1));
        this.form.networkBudget = value.substring(1);
      } else {
        this.form.networkBudget = value.replace(/[^0-9]/g, '');
        // console.log(this.form.networkBudget, value, value.replace(/[^0-9]/g, ''));
      }
    },
    handleDirChange (id) {
      let dir = this.relatedRAP.find(item => item.companyCode === id);
      // eslint-disable-next-line no-undef
      // this.from[companyCode] = dir.companyCode;
      this.form['companyName'] = dir.companyName;
      this.form['parentCompanyName'] = dir.companyName;
      this.form['parentCompanyCode'] = dir.companyCode;
      console.log(dir);
    },
    BrazilianTaxNumber () {
      // console.log(this.form.areaCode);
      // eslint-disable-next-line eqeqeq
      if (this.form.areaCode == 'BR') {
        this.BrazilianTax = true;
      } else {
        this.BrazilianTax = false;
      }
    },
    async handleUpload ({ file, onSuccess }) {
      if (file.size === 0) {
        this.$message.warning('上传文件大小为0');
        return this.message.warn('上传文件大小为0');
      }
      if (file.size > 31457280) {
        this.$message.warning('上传文件大小应在30M以内');
        return this.message.warn('上传文件大小应在30M以内');
      }
      // eslint-disable-next-line no-unused-vars
      let num = 1;
      this.attachment.forEach(item => {
        if (item.isActive) {
          num++;
        }
      });
      // console.log(num);
      if (num > 9) {
        this.$message.warning('上传文件应在9个以内');
        return this.message.warn('上传文件应在9个以内');
      }
      // 保存文件的信息
      let saveFileParams = {};
      const uploadParams = {
        file,
        config: {
          originalFilename: file.name,
          contentType: file.type,
          service: 'prm',
          module: 'prm-order',
          userId: store.state.user.userId,
          privateBucket: true
        },
        onProgress: (p) => {
          this.uploadProgress = Big(getNum(p)).times(100).toFixed(2);
        }
      };
      try {
        console.log(uploadParams);
        const { res, name } = await uploadFile(uploadParams);
        if (res.status === 200) {
          saveFileParams = {
            service: 'prm',
            size: file.size,
            objectName: name,
            module: 'prm-order',
            userId: store.state.user.userId,
            contentType: file.type,
            originalFilename: file.name,
            privateBucket: true
          };
          // console.log(file, 999);
          const { status, data } = await saveFileInfo(saveFileParams);
          if (status === '200') {
            const uploadParam = {
              type: this.uploadData.type,
              ossFileId: data.id,
              ossFileName: data.name,
              ossFileUrl: data.path
            };
            API.postOssUpload(uploadParam).then(res => {
              // eslint-disable-next-line no-undef
              file['id'] = res.data.data;
              this.attachmentId = res.data.data;
              this.attachmentName = data.name;
              this.attachment.push({
                id: this.attachmentId,
                name: this.attachmentName,
                isActive: true
              });
            }).catch(e => {
              this.$message.warning('上传失败');
            });
          }
        }
        // console.log(this.attachment, file);
      } catch (e) {
        console.log(e);
      }
    },
    downloadUpload (id) {
      APIS.getAliOSSDownloadInfo(id).then(async (res) => {
        window.open(res.data.data.fileInfo.url);
      }).catch(e => {
        console.log(e);
      });
    },
    getCurUserChannelInfo () {
      API.getCurUser().then(res => {
        let json = res.data;
        if (json.status === '200') {
          if (json.data.ruijieSaleName == null || json.data.partnerName == null) {
            this.$message.error(this.$t('message.unbound'));
          }
          this.form.partnerName = json.data.partnerName;
          this.form.partnerCode = json.data.partnerCode;
          this.form.partnerAreaCode = json.data.partnerAreaCode;
          this.form.areaCode = json.data.partnerAreaCode;
          this.form.partnerType = json.data.partnerType;
          this.form.partnerTypeName = json.data.partnerTypeName;
          this.form.partnerEmail1 = json.data.partnerEmail1;
          this.readAndAgree = json.data.agreeClause;
          if (this.readAndAgree === false) {
            this.$message.error(this.$t('message.pleaseReadAndAgreeClause'));
          }
          this.form.ruijieSaleId = json.data.ruijieSaleId;
          this.form.ruijieSaleName = json.data.ruijieSaleName;
          this.form.taxNumber = json.data.taxNumber;
          this.form.ruijieSaleEmail = json.data.ruijieSaleEmail;
        }
      }).catch(e => {
        console.log(e);
      });
    },
    getByMasterAccount () {
      // console.log(store.state.user.userId);
      API.getByMasterAccount(store.state.user.userId).then(res => {
      // API.getByMasterAccount('bobolau@ttdist.com').then(res => {
        let json = res.data;
        // console.log(json);
        if (json.status === '200') {
          this.relatedRAP = json.data;
        }
      }).catch(e => {
        console.log(e);
      });
    },
    getPartnerDetail () {
      API.getPartnerDetail().then(res => {
        let json = res.data;
        if (json.status === '200') {
          console.log(json);
          this.form.linkManEmail1 = json.data.linkManEmail1;
          this.form.linkManEmail2 = json.data.linkManEmail2;
        }
      }).catch(e => {
        console.log(e);
      });
    },
    getProBaseInfo (id) {
      API.getProBaseInfo(id, this.language).then(res => {
        let json = res.data;
        if (json.status === '200') {
          this.attachment = json.data.attachment;
          this.form = json.data;
          this.form.expectedOrderDate = parseTime(json.data.expectedOrderDate, '{y}-{m}-{d}');
          this.form.projectBudget = moneyFormat(json.data.projectBudget);
          this.form.networkBudget = moneyFormat(json.data.networkBudget);
          this.canSubmit = json.data.canSubmit;
          // this.form.relatedRAP = json.data.parentCompanyCode;
          // console.log(this.form.relatedRAP);
          // 基础表存储的值不是String的(下拉数据值统一是String类型)，转为String类型
          if (typeof (this.form.fundsInPlace) !== 'string') {
            this.form.fundsInPlace = this.form.fundsInPlace.toString();
          }
          if (typeof (this.form.isSupportRuijie) !== 'string') {
            this.form.isSupportRuijie = this.form.isSupportRuijie.toString();
          }
          if (typeof (this.form.hasCooperated) !== 'string') {
            this.form.hasCooperated = this.form.hasCooperated.toString();
          }
          if (typeof (this.form.projectPhase) !== 'string') {
            this.form.projectPhase = this.form.projectPhase.toString();
          }
          if (typeof (this.form.jointVisit) !== 'string') {
            this.form.jointVisit = this.form.jointVisit.toString();
          }
        }
      }).catch(e => {
        console.log(e);
      });
    },
    getCountries () {
      API.getAllCountries(this.$i18n.locale).then(res => {
        let json = res.data;
        if (json.status === '200') {
          this.allCountries = json.data;
        }
      }).catch(e => {
        console.log(e);
      });
    },
    getSelectData () {
      API.getPrmSelectData(this.language).then(res => {
        let json = res.data;
        if (json.status === '200') {
          this.fundsInPlaceList = json.data.fundsInPlaceData;
          this.isSupportRuijieList = json.data.isSupportRuijieData;
          this.hasCooperatedList = json.data.yorNData;
          // this.projectPhaseList = json.data.projectPhaseData;
          this.jointVisitList = json.data.jointVisitData;
        }
      }).catch(e => {
        console.log(e);
      });
      API.getProjectStep(this.$i18n.locale)
        .then((res) => {
          let json = res.data;
          if (json.status === '200') {
            // console.log(json.data, 8888);
            this.projectPhaseList = json.data;
          }
        })
        .catch((e) => {
          console.log(e);
        });
    },
    countryChange (val) {
      API.getSaleByArea(val).then(res => {
        let json = res.data;
        if (json.status === '200' && json.data) {
          this.form.ruijieSaleId = json.data.userId;
          this.form.ruijieSaleName = json.data.userName;
          this.form.taxNumber = json.data.userName;
          this.form.ruijieSaleEmail = json.data.userEmail;
        } else {
          this.form.ruijieSaleId = '';
          this.form.ruijieSaleName = '';
          // 需要注意
          this.form.taxNumber = '';
          this.form.ruijieSaleEmail = '';
        }
      }).catch(e => {
        console.log(e);
      });
    },
    fundsInPlaceChange (val) {
      this.fundsInPlaceList.forEach(item => {
        if (item.dataValue === val) {
          this.form.fundsInPlaceKey = item.languageKey;
        }
      });
    },
    isSupportRuijieChange (val) {
      this.isSupportRuijieList.forEach(item => {
        if (item.dataValue === val) {
          this.form.isSupportRuijieKey = item.languageKey;
        }
      });
    },
    hasCooperatedChange (val) {
      this.hasCooperatedList.forEach(item => {
        if (item.dataValue === val) {
          this.form.hasCooperatedKey = item.languageKey;
        }
      });
    },
    changeHasCooperated (val) {
      // console.log(val);
      if (val === '1') {
        // console.log(111111);
        this.form.hasCooperatedKey = 'YN_1';
      } else {
        this.form.hasCooperatedKey = 'YN_0';
      }
    },
    projectPhaseChange (val) {
      this.projectPhaseList.forEach(item => {
        // console.log(item);
        if (item.languageKey === val) {
          // console.log(item, 8888);
          this.form.projectPhaseKey = item.languageKey;
          this.form.projectPhaseValue = item.languageValue;
        }
      });
    },
    jointVisitChange (val) {
      this.jointVisitList.forEach(item => {
        if (item.dataValue === val) {
          this.form.jointVisitKey = item.languageKey;
        }
      });
    },
    toList () {
      window.history.go(-1);
    },
    clickSaveDraft () {
      this.draftBtnDisabled = true;
      let isPass = true;
      this.$refs.prmForm.validateField('projectName', (projectNameValid) => {
        if (projectNameValid) {
          isPass = false;
        }
      });
      if (isPass) {
        let body = {
          proBase: this.form,
          templateId: this.templateId,
          attachment: this.attachment
        };
        this.pageloading = true;
        this.form.projectBudget = this.form.projectBudget.toString().replace(new RegExp(',', 'g'), '');
        this.form.networkBudget = this.form.networkBudget.toString().replace(new RegExp(',', 'g'), '');
        API.savePrmDraft(body).then(res => {
          let json = res.data;
          if (json.status === '200') {
            this.form.id = json.data.id;
            this.$notify({
              title: this.$t('message.saveSuccess'),
              type: 'success'
            });
          }
        }).catch(e => {
          console.log(e);
        }).finally(() => {
          this.pageloading = false;
          this.draftBtnDisabled = false;
        });
      } else {
        this.draftBtnDisabled = false;
        this.$refs.projectName.focus();
      }
    },
    clickSave () {
      // console.log(this.attachment);
      this.saveBtnDisabled = true;
      this.$refs.prmForm.validate((valid, validator) => {
        if (valid) {
          this.pageloading = true;
          this.form.projectBudget = this.form.projectBudget.toString().replace(new RegExp(',', 'g'), '');
          this.form.networkBudget = this.form.networkBudget.toString().replace(new RegExp(',', 'g'), '');
          let body = {
            proBase: this.form,
            templateId: this.templateId,
            attachment: this.attachment
          };
          API.updatePrmBaseInfo(body).then(res => {
            let json = res.data;
            if (json.status === '200') {
              this.form = json.data;
              this.$notify({
                title: this.$t('message.saveSuccess'),
                type: 'success'
              });
              this.pageloading = false;
              this.saveBtnDisabled = false;
            }
          }).catch(e => {
            this.pageloading = false;
            this.saveBtnDisabled = false;
          });
        } else {
          this.saveBtnDisabled = false;
          let first = Object.keys(validator)[0];
          this.$refs[first].focus();
          return false;
        }
      });
    },
    clickSubmit () {
      // console.log(this.attachment);
      this.submitBtnDisabled = true;
      this.$refs.prmForm.validate((valid, validator) => {
        if (valid) {
          this.form.projectBudget = this.form.projectBudget.toString().replace(new RegExp(',', 'g'), '');
          this.form.networkBudget = this.form.networkBudget.toString().replace(new RegExp(',', 'g'), '');
          // eslint-disable-next-line eqeqeq
          // if (this.from.hasCooperated == 'No') {
          //   this.from.hasCooperated = 0;
          // } else {
          //   this.from.hasCooperated = 1;
          // }
          // console.log(this.form);
          let body = {
            proBase: this.form,
            templateId: this.templateId,
            attachment: this.attachment
          };
          this.pageloading = true;
          // eslint-disable-next-line no-undef
          // console.log(this.form, 88888);
          API.submitPrm(body).then(res => {
            let json = res.data;
            this.pageloading = false;
            if (json.status === '200') {
              this.$notify({
                title: this.$t('message.submitSuccess'),
                type: 'success'
              });
              // this.$router.go(0);
              window.location.href = '/prm/list';
              // this.$router.push({ path: '/prm/list' });
              // this.$router.replace('/prm/list');
              this.submitBtnDisabled = false;
            }
          }).catch(e => {
            this.pageloading = false;
            this.submitBtnDisabled = false;
          });
        } else {
          this.submitBtnDisabled = false;
          let first = Object.keys(validator)[0];
          this.$refs[first].focus();
          return false;
        }
        this.submitBtnDisabled = false;
      });
    },
    beforeUpload (file) {
      this.isUpLoad = true;
      this.uploadSuccess = false;
    },
    cancelFile (value) {
      this.attachment.forEach(item => {
        if (item.id === value) {
          item.isActive = false;
        }
      });
      // console.log(this.attachment);
    },
    uploadremove (file, fileList) {
      // console.log(8888888888, file.raw.id, fileList, this.attachment);
      this.attachment.forEach(item => {
        if (item.id === file.raw.id) {
          item.isActive = false;
        }
      });
      // console.log(this.attachment);
    },
    uploadsuccess (response, file, fileList) {
      this.fileList = [file];
      if (response.status === '200') {
        this.attachmentId = response.data.id;
        this.attachmentName = response.data.name;
        this.uploadSuccess = true;
      } else {
        this.$notify({
          title: response.data.err,
          type: 'error'
        });
      }
    },
    uploaderror (response, file, fileList) {
      this.isUpLoad = false;
      this.uploadSuccess = false;
    },
    checkBudget (rule, value, callback) {
      let reg = /^\d{1,12}(\.\d{1,2})?$/;
      value = value.toString().replace(new RegExp(',', 'g'), '');
      if (!reg.test(value)) {
        callback(new Error(this.$t('message.budgetNotAllow')));
      } else {
        callback();
      }
    },
    projectBudgetChange (val) {
      let value0 = val.toString().replace(new RegExp(',', 'g'), '');
      let value = Number(value0);
      if (value) {
        this.form.projectBudget = moneyFormat(Math.floor(value * 100) / 100);
      }
    },
    networkBudgetChange (val) {
      let value0 = val.toString().replace(new RegExp(',', 'g'), '');
      let value = Number(value0);
      // console.log(value);
      if (value) {
        this.form.networkBudget = moneyFormat(Math.floor(value * 100) / 100);
      }
    },
    checkFinalCompanyName (rule, value, callback) {
      if (value === undefined || value === '' || value.trim() === '') {
        callback(new Error(this.$t('message.needFinalCompanyName')));
      } else {
        let body = {
          fieldName: 'finalCompanyName',
          content: value
        };
        API.checkRiskLevel(body).then(res => {
          let json = res.data;
          if (json.data === '200') {
            callback();
          } else if (json.data === '30002') {
            callback(new Error(json.msg));
          } else {
            callback();
          }
        }).catch(e => {
          callback();
          console.error('校验最终用户公司名称限制等级发生异常：', e);
        });
      }
    },
    handleSelectClear () {
      this.getTwoPartnerListData('');
    },
    handleRelatedChange (value) {
      this.form.twoPartnerCode = value;
      let params = this.twoPartnerList.find(item => item.companyCode === value);
      this.form.twoPartnerName = params.companyName;
      this.form.twoPartnerCode = params.companyCode;
      console.log(this.form);
    },
    handleRelatedInput (event) {
      this.form.twoPartnerName = event.target.value.trim();
      this.form.twoPartnerCode = '';
      this.getTwoPartnerListData(this.form.twoPartnerName);
      console.log(this.form);
    },
    getTwoPartnerListData (companyName) {
      API.getTwoPartnerListL(this.form.partnerCode, companyName).then(res => {
        let json = res.data;
        if (json.status === '200') {
          this.twoPartnerList = json.data;
        }
      }).catch(e => {
        console.log(e);
      });
    }
  },
  computed: {
    prmRule () {
      return {
        partnerName: [
          { required: true, message: this.$t('message.needPartnerName'), trigger: 'blur' }
        ],
        projectName: [
          { required: true, message: this.$t('message.needProjectName'), trigger: 'blur' }
        ],
        areaCode: [
          { required: true, message: this.$t('message.needCountry'), trigger: 'blur' }
        ],
        finalCompanyName: [
          { required: true, message: this.$t('message.needFinalCompanyName'), trigger: 'blur' }
          // { required: true, validator: this.checkFinalCompanyName, trigger: 'blur' }
        ],
        finalCompanyAddress: [
          { required: true, message: this.$t('message.needFinalCompanyAddress'), trigger: 'blur' }
        ],
        /* finalUserName: [
          { required: true, message: this.$t('message.needFinalUserName'), trigger: 'blur' }
        ],
        finalUserPosition: [
          { required: true, message: this.$t('message.needFinalUserPosition'), trigger: 'blur' }
        ],
        finalUserTel: [
          { required: true, message: this.$t('message.needFinalUserTel'), trigger: 'blur' }
        ],
        finalUserEmail: [
          { required: true, message: this.$t('message.needFinalUserEmail'), trigger: 'blur' },
          { type: 'email', message: this.$t('message.needBeEmail'), trigger: 'blur' }
        ], */
        /* fundsInPlace: [
          { required: true, message: this.$t('message.needFundsInPlace'), trigger: 'blur' }
        ], */
        /* projectBudget: [
          { required: true, message: this.$t('message.needProjectBudget'), trigger: 'blur' },
          { required: true, validator: this.checkBudget, trigger: 'blur' }
        ], */
        networkBudget: [
          { required: true, message: this.$t('message.needNetworkBudget'), trigger: 'blur' },
          { required: true, validator: this.checkBudget, trigger: 'blur' }
        ],
        expectedOrderDate: [
          { required: true, message: this.$t('message.needExpectedOrderDate'), trigger: 'blur' }
        ],
        isSupportRuijie: [
          { required: true, message: this.$t('message.needIsSupportRuijie'), trigger: 'blur' }
        ],
        hasCooperated: [
          { required: true, message: this.$t('message.needHasCooperated'), trigger: 'blur' }
        ],
        // BrazilianTaxNumbers: [
        //   { required: this.BrazilianTax, message: this.$t('message.needRuijieSaleName'), trigger: 'blur' }
        // ],
        ruijieSaleName: [
          { required: true, message: this.$t('message.needRuijieSaleName'), trigger: 'blur' }
        ],
        projectRequirements: [
          { required: true, message: this.$t('message.needProjectRequirements'), trigger: 'blur' }
        ],
        partnerEmail: [
          { required: true, message: this.$t('message.needPartnerEmail'), trigger: 'blur' },
          { type: 'email', message: this.$t('message.needBeEmail'), trigger: 'blur' }
        ],
        partnerContactName: [
          { required: true, message: this.$t('message.needPartnerContactName'), trigger: 'blur' }
        ],
        partnerPhone: [
          { required: true, message: this.$t('message.needPartnerPhone'), trigger: 'blur' }
        ],
        /* jointVisit: [
          { required: true, message: this.$t('message.needJointVisit'), trigger: 'blur' }
        ], */
        projectPhase: [
          { required: true, message: this.$t('message.needProjectPhase'), trigger: 'blur' }
        ]
      };
    }
  },
  mounted () {
    this.getSelectData();
    this.getCountries();
  }
};
